import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import DespesaIcon from "../../assets/icons/despesas.png";
import ItensDespesasService from "../../services/DespesasItensService";
import CategoriasDespesasService from "../../services/DespesasCategoriasService";

export default function ItensDespesasForm({
  itemSelecionado,
  modo,
  onClose,
}) {
  const [form, setForm] = useState({
    idItemDespesa: null,
    descricao: "",
    tipoValor: "",
    valor: "",
    vencimento: "",
    observacao: "",
    idCategoriaDespesa: "",
    ativo: true,
  });

  const [categorias, setCategorias] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idItemDespesa: null,
        descricao: "",
        tipoValor: "",
        valor: "",
        vencimento: "",
        observacao: "",
        idCategoriaDespesa: "",
        ativo: true,
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idItemDespesa: itemSelecionado.IDITEMDESPESA,
        descricao: itemSelecionado.DESCRICAO,
        tipoValor: itemSelecionado.TIPO_VALOR,
        valor: itemSelecionado.valor ?? "",
        vencimento: itemSelecionado.VENCIMENTO ?? "",
        observacao: itemSelecionado.OBSERVACAO ?? "",
        idCategoriaDespesa: itemSelecionado.IDCATEGORIADESPESA,
        ativo: itemSelecionado.ATIVO,
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // Carregar Categorias
  // ==========================
  useEffect(() => {
    async function carregarCategorias() {
      try {
        const dados = await CategoriasDespesasService.getAll();
        setCategorias(dados);
      } catch (error) {
        console.error("Erro ao carregar categorias", error);
      }
    }
    carregarCategorias();
  }, []);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;

    if (name === "ativo") {
      setForm(prev => ({ ...prev, ativo: value === "true" }));
      return;
    }

    setForm(prev => ({
      ...prev,
      [name]: value,
    }));
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};
    if (!form.descricao) e.descricao = "Informe a descrição";
    if (!form.tipoValor) e.tipoValor = "Informe o tipo";
    if (!form.idCategoriaDespesa) e.idCategoriaDespesa = "Selecione a categoria";
    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      if (modo === "novo") {
        const payload_create = {
          DESCRICAO: form.descricao,
          TIPO_VALOR: form.tipoValor,
          VALOR: form.valor,
          VENCIMENTO: form.vencimento ? Number(form.vencimento) : null,
          OBSERVACAO: form.observacao,
          IDCATEGORIADESPESA: form.idCategoriaDespesa,
        };

        await ItensDespesasService.create(payload_create);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Item de despesa criado com sucesso!",
        });
      }

      if (modo === "alterar") {
        const payload_update = {
          IDITEMDESPESA: form.idItemDespesa,
          DESCRICAO: form.descricao,
          TIPO_VALOR: form.tipoValor,
          VALOR: form.valor,
          VENCIMENTO: form.vencimento ? Number(form.vencimento) : null,
          OBSERVACAO: form.observacao,
          IDCATEGORIADESPESA: form.idCategoriaDespesa,
          ATIVO: Boolean(form.ativo),
        };

        await ItensDespesasService.update(form.idItemDespesa, payload_update);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Item de despesa atualizado com sucesso!",
        });
      }

      setSubmitState("SUCCESS");
      onClose();
    } catch {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar item de despesa."
            : "Erro ao atualizar item de despesa.",
      });
      setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={DespesaIcon} alt="" className="icon" />
          {modo === "novo" ? "Cadastro de Item de Despesa" : "Alterar Item de Despesa"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Categoria *</div>
          <select
            name="idCategoriaDespesa"
            value={form.idCategoriaDespesa}
            onChange={handleChange}
          >
            <option value="">Selecione</option>
            {categorias.map(c => (
              <option key={c.IDCATEGORIADESPESA} value={c.IDCATEGORIADESPESA}>
                {c.DESCRICAO}
              </option>
            ))}
          </select>
          {errors.idCategoriaDespesa && <span className="erro">{errors.idCategoriaDespesa}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição *</div>
          <input name="descricao" value={form.descricao} onChange={handleChange} />
          {errors.descricao && <span className="erro">{errors.descricao}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Tipo *</div>
          <select name="tipoValor" value={form.tipoValor} onChange={handleChange}>
            <option value="">Selecione</option>
            <option value="F">Fixa</option>
            <option value="V">Variável</option>
          </select>
          {errors.tipoValor && <span className="erro">{errors.tipoValor}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Valor</div>
          <input name="valor" value={form.valor} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Vencimento (dia)</div>
          <input name="vencimento" value={form.vencimento} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Observação</div>
          <input name="observacao" value={form.observacao} onChange={handleChange} />
        </div>

        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Ativo</div>
            <select name="ativo" value={String(form.ativo)} onChange={handleChange}>
              <option selected value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        )}

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Enviando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
